// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#forgetPassword .el-loading-spinner{margin-top:-10px}#forgetPassword .el-loading-spinner .circular{width:20px;height:20px}", ""]);
// Exports
module.exports = exports;
